const etagStore = new Map();

export function getEtag(key) {
  return etagStore.get(key);
}

export function setEtag(key, value) {
  etagStore.set(key, value);
}
